import PropTypes from 'prop-types';

// A helper layout wrapper to ensure consistent SVG scaling and styling.
const BaseSvg = ({ size = 20, color = 'currentColor', strokeWidth = 2, className = '', children, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`custom-svg-icon ${className}`}
    style={{ display: 'inline-block', verticalAlign: 'middle', ...props.style }}
    {...props}
  >
    {children}
  </svg>
);

BaseSvg.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
};

export const DashboardIcon = (props) => (
  <BaseSvg {...props}>
    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </BaseSvg>
);

export const TicketIcon = (props) => (
  <BaseSvg {...props}>
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
    <line x1="7" y1="7" x2="7.01" y2="7" />
  </BaseSvg>
);

export const FolderIcon = (props) => (
  <BaseSvg {...props}>
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
  </BaseSvg>
);

export const UserIcon = (props) => (
  <BaseSvg {...props}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </BaseSvg>
);

export const UsersIcon = (props) => (
  <BaseSvg {...props}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </BaseSvg>
);

export const ShieldIcon = (props) => (
  <BaseSvg {...props}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </BaseSvg>
);

export const BuildingIcon = (props) => (
  <BaseSvg {...props}>
    <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
    <line x1="9" y1="22" x2="9" y2="16" />
    <line x1="15" y1="22" x2="15" y2="16" />
    <line x1="9" y1="16" x2="15" y2="16" />
    <path d="M8 6h.01M16 6h.01M8 10h.01M16 10h.01M12 6h.01M12 10h.01M8 14h.01M16 14h.01" />
  </BaseSvg>
);

export const BellIcon = (props) => (
  <BaseSvg {...props}>
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </BaseSvg>
);

export const KeyIcon = (props) => (
  <BaseSvg {...props}>
    <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
  </BaseSvg>
);

export const PlusIcon = (props) => (
  <BaseSvg {...props}>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </BaseSvg>
);

export const EditIcon = (props) => (
  <BaseSvg {...props}>
    <path d="M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
  </BaseSvg>
);

export const MessageIcon = (props) => (
  <BaseSvg {...props}>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </BaseSvg>
);

export const BugIcon = (props) => (
  <BaseSvg {...props}>
    <rect x="8" y="6" width="8" height="12" rx="4" />
    <path d="M12 6V3M8 8H4M8 12H4M8 16H4M16 8h4M16 12h4M16 16h4M12 18v3" />
  </BaseSvg>
);

export const ClockIcon = (props) => (
  <BaseSvg {...props}>
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </BaseSvg>
);

export const SearchIcon = (props) => (
  <BaseSvg {...props}>
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </BaseSvg>
);

export const ChevronDownIcon = (props) => (
  <BaseSvg {...props}>
    <polyline points="6 9 12 15 18 9" />
  </BaseSvg>
);

export const ChevronUpIcon = (props) => (
  <BaseSvg {...props}>
    <polyline points="18 15 12 9 6 15" />
  </BaseSvg>
);

export const ArrowUpDownIcon = (props) => (
  <BaseSvg {...props}>
    <polyline points="8 9 12 5 16 9" />
    <polyline points="16 15 12 19 8 15" />
  </BaseSvg>
);

export const CloseIcon = (props) => (
  <BaseSvg {...props}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </BaseSvg>
);

export const MenuIcon = (props) => (
  <BaseSvg {...props}>
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </BaseSvg>
);
